export default __webpack_public_path__ + "static/cross-lines-2e8a4b2a57fb76bc112ba786ebe1f858.png";